import { Component, Input } from '@angular/core';
import { AdminFileManagementUploadComponent } from "../admin-file-management-upload/admin-file-management-upload.component";
import { IsoToFormattedDatePipe } from "../../../../core/pipes/iso-to-formatted-date.pipe";
import { TranslocoPipe } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { FileManagementService } from '../../../../core/api/file-management.service';
import { ApiErrorService } from '../../../../core/api/api-error.service';
import { AdminFileGet, AdminFileType } from '../../../../core/interfaces/file-management-interfaces';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';
import { HttpErrorResponse } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-admin-accise-gas-files',
  standalone: true,
  imports: [AdminFileManagementUploadComponent, IsoToFormattedDatePipe, TranslocoPipe, CommonModule],
  templateUrl: './admin-accise-gas-files.component.html',
  styleUrl: './admin-accise-gas-files.component.css'
})
export class AdminAcciseGasFilesComponent {
  constructor(private fileManagement: FileManagementService, private apiError: ApiErrorService) { }
  AdminFileType = AdminFileType;
  @Input() toast?: ToastComponent;

  acciseGasFiles: AdminFileGet[] = [];

  ngOnInit(): void {
    this.loadAcciseGas();
  }

  loadAcciseGas() {
    this.fileManagement.getAcciseGas().subscribe({
      next: (response) => {
        if (response) {
          this.acciseGasFiles = [];
          this.acciseGasFiles = response;
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        }
        this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      },
      complete: () => {
      }
    });
  }

  async getFileManagementFileUrl(fileId: string) {
    try {
      var response = await lastValueFrom(this.fileManagement.downloadFile(fileId));
      return response.download_url;

    } catch (error) {
      var crid = 'UNKNOWN-CRID';

      if (error instanceof HttpErrorResponse) {
        crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
      }
      this.toast?.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
    }
    return null;
  }

  async downloadFile(fileId: string) {
    const fileUrl = await this.getFileManagementFileUrl(fileId || '');
    if (fileUrl) {
      window.open(fileUrl, '_blank');
    }
  }
}
